import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { WorkflowAutoUpload } from 'app/models/workflow-auto-upload';
import { WorkflowFile } from 'app/models/workflow-file';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { MdbCheckboxChange, ModalDirective } from 'ng-uikit-pro-standard';
import { AbstractPickedFile, CloudPickedFile } from 'app/models/picked-file';
import { PrefixSuffixBuilderComponent } from 'app/views/prefix-suffix-builder/prefix-suffix-builder.component';
import { WorkflowForm } from 'app/models/workflow-form';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { FileClass } from 'app/models/file-class';
import { FileClassService } from 'app/services/file-class.service';
import { Form } from '@atefhashem/eforms';
import { timeZoneNames } from 'app/helpers/timezone-options';

@Component({
  selector: 'app-add-save-rule',
  templateUrl: './add-save-rule.component.html',
  styleUrls: ['./add-save-rule.component.scss']
})
export class AddSaveRuleComponent implements OnInit {

  constructor(private fileClassService: FileClassService, private validationHandler: ValidationHandler, private workflowTemplateService: WorkflowTemplateService) { }

  ngOnInit() {
    this.fileClassService.list().subscribe((f) => {
      this.fileClasses = f;
    });
  }

  @Output() addEditAccepted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @Input() workflowForms: WorkflowForm[];
  @Input() workflowFiles: WorkflowFile[];
  @Input() isEdit: boolean;

  @Input() forExecution: boolean = false;

  autoUploadRuleToAddFormGroup: FormGroup;

  @ViewChild('selectAllFormsComponent', { static: false }) selectAllFormsComponent: NgSelectComponent;
  @ViewChild('selectAllFilesComponent', { static: false }) selectAllFilesComponent: NgSelectComponent;
  @ViewChild('addEditAutoUploadModal', { static: true }) addEditAutoUploadModal: ModalDirective;
  @ViewChild('fillMetadataModal', { static: true }) fillMetadataModal: ModalDirective;
  @ViewChild('prefixBuilder', { static: false }) prefixBuilder: PrefixSuffixBuilderComponent;
  @ViewChild('suffixBuilder', { static: false }) suffixBuilder: PrefixSuffixBuilderComponent;
  @ViewChild('renameBuilder', { static: false }) renameBuilder: PrefixSuffixBuilderComponent;
  @ViewChild('additionalPathBuilder', { static: false }) additionalPathBuilder: PrefixSuffixBuilderComponent;
  @ViewChild('metadataFormatBuilder', { static: false }) metadataFormatBuilder: PrefixSuffixBuilderComponent;
  
  additionalPathIndexToBuilder: number = 0;
  metadataIndexToBuild: number = 0;

  fileClasses: FileClass[] = [];
  metadataForms: any[] = [];
  uniqueID: string = '';

  show(frm: FormGroup) {
    this.uniqueID =  Math.random().toString(36).substr(2, 9);

    this.autoUploadRuleToAddFormGroup = frm;
    this.addEditAutoUploadModal.show();
  }

  onOpened() {
    this.selectAllFormsComponent.setDisabledState(this.autoUploadRuleToAddFormGroup.value.is_all_forms == true);
    this.selectAllFilesComponent.setDisabledState(this.autoUploadRuleToAddFormGroup.value.is_all_files == true);
  }
  
  onAddAutoUploadModalAddClick() {
    this.validationHandler.onSubmitCheck(this.autoUploadRuleToAddFormGroup);
    if(!this.autoUploadRuleToAddFormGroup.valid){
      return;
    }

    this.addEditAccepted.emit(this.autoUploadRuleToAddFormGroup);
    this.addEditAutoUploadModal.hide();
  }

  onAllFilesChange(e: MdbCheckboxChange) {
    this.selectAllFilesComponent.setDisabledState(e.checked);
    if (e.checked) {
      this.autoUploadRuleToAddFormGroup.controls['files'].reset();
      this.autoUploadRuleToAddFormGroup.controls['file_rename'].reset();
    }
  }

  onAllFormsChange(e: MdbCheckboxChange) {
    this.selectAllFormsComponent.setDisabledState(e.checked);
    if (e.checked) {
      this.autoUploadRuleToAddFormGroup.controls['forms'].reset();
      this.autoUploadRuleToAddFormGroup.controls['file_rename'].setValue('');
    }
  }

  onFilesFormsChange(totalLength: number) {
    if (totalLength > 1) {
      this.autoUploadRuleToAddFormGroup.controls['file_rename'].setValue('');      
    }
  }
  onPickedDestination(e: AbstractPickedFile[]) {
    let cloudPickedFolder = e[0] as CloudPickedFile;
    this.autoUploadRuleToAddFormGroup.get('storage').setValue({id: cloudPickedFolder.storageId, display_name: cloudPickedFolder.storageName});
    this.autoUploadRuleToAddFormGroup.get('storage_id').setValue(cloudPickedFolder.storageId);
    this.autoUploadRuleToAddFormGroup.get('path').setValue(cloudPickedFolder.path);

  }

  addAdditionalPathFormControl() {
    this.workflowTemplateService.addAdditionalEmptyPathToAutoUploadRule(this.autoUploadRuleToAddFormGroup);
  }

  removeAdditionalPathFormControlAt(index: number) {
    (<FormArray>this.autoUploadRuleToAddFormGroup.get('additional_paths')).removeAt(index);
  }

  onFillMetadata() {
    this.addEditAutoUploadModal.hide();
    this.fillMetadataModal.show();
  }

  onClassChanged(newClass: FileClass) {
      this.autoUploadRuleToAddFormGroup.controls['metadata'] = this.workflowTemplateService.generateMetadataFormArray(newClass);
      this.autoUploadRuleToAddFormGroup.controls['metadata'].setParent(this.autoUploadRuleToAddFormGroup);
  }

  onMetadataModalShown() {
    this.metadataForms = [];
    (<FormArray>this.autoUploadRuleToAddFormGroup.get('metadata')).controls.forEach((m, index) => {
      var formioForm = new Form(document.getElementById('field_filler_' + this.uniqueID + '_' + index), { components: [m.value.schema] }, { renderMode: 'form', noAlerts: true});

      formioForm.ready.then((f) => {
        this.metadataForms[index] = f;
        if (!m.value.auto_upload_metadata_settings.is_dynamic_value && m.value.auto_upload_metadata_settings.value) {
          f.submission = { data: {[m.value.key]: m.value.auto_upload_metadata_settings.value } };
        }        
      });
    });
  }

  onFillMetadataSave() {
    var metadataFormErrors = false;
    this.metadataForms.forEach((f, index) => {
      if (!this.autoUploadRuleToAddFormGroup.value.metadata[index].auto_upload_metadata_settings.is_dynamic_value) {
        f.submit();
        metadataFormErrors = metadataFormErrors || !f.checkValidity(f.submission.data);
      }
    });

    if (metadataFormErrors) {
      return;
    }

    this.metadataForms.forEach((f, index) => {
      if (!this.autoUploadRuleToAddFormGroup.value.metadata[index].auto_upload_metadata_settings.is_dynamic_value) {
        this.autoUploadRuleToAddFormGroup.get('metadata.' + index + '.auto_upload_metadata_settings.value').setValue(f.submission.data[this.autoUploadRuleToAddFormGroup.value.metadata[index].key]);
      }
    });
    
    this.validationHandler.onSubmitCheck(this.autoUploadRuleToAddFormGroup);
    if(!this.autoUploadRuleToAddFormGroup.controls['metadata'].valid) {
      return;
    }

    this.fillMetadataModal.hide();
    this.addEditAutoUploadModal.show();
  }

  timeZoneOptions() : string[] {
    return timeZoneNames;
  }
}
